import ApplicantInformation from './container/ApplicantInformation';

export default ApplicantInformation;



// WEBPACK FOOTER //
// ./src/views/ApplicantInformation/index.js